import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  BarElement,
  ChartOptions,
} from "chart.js";
import React, { useEffect, useState, MouseEvent, ChangeEvent, useMemo } from "react";
import stats from "../models/stats";
import ExportModal from "./ExportModal";
import { AVERAGE, graphingMap, makeChartData } from "./chartService";
import { ColorRing } from "react-loader-spinner";
import LineChart from "./LineChart";
import ChartAnnotation from 'chartjs-plugin-annotation';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ChartAnnotation,
);

interface Props {
  // placeName?: String;
  groupId?: number;
  startyear?: number | 0;
  startmonth?: number | 1;
  startday?: number | 1;
  // place: any;
  setCurrentData?: (data: stats) => void;
  setCurrentStatus?: any;
}
const firstUnit = Object.keys(graphingMap).map(key => graphingMap[key])[0] //component needs some type of unit to load into DOM
const Charts = ({ groupId, setCurrentData, setCurrentStatus, startyear, startmonth, startday }: Props) => {
  const [dataOne, setData] = useState<any[]>([]);
  const [range, setRange] = useState("24hrs");

  const [startyeardef, setStartyear] = useState(startyear);
  const [startmonthdef, setStartmonth] = useState(startmonth);
  const [startdaydef, setStartday] = useState(startday);

  const [reload, setReload] = useState(false);
  const [sensor, setSensor] = useState(firstUnit);

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [showAllSensors, setShowAllSensors] = useState(true);
  const [showRawData, setShowRawData] = useState(false);
  const [showSD, setShowSD] = useState(false);
  const [showAvg, setShowAvg] = useState(false);
  const [sensorsOnGraph, setSensorsOnGraph] = useState([])

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    setRange(e.target.value);
  };
  const handleTimeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (e.target.name === "startyear") {
      setStartyear(Number(e.target.value));
    }
    if (e.target.name === "startmonth") {
      setStartmonth(Number(e.target.value));
    }
    if (e.target.name === "startday") {
      setStartday(Number(e.target.value));
    }
  };
  const handleDataSet = (e: MouseEvent, name: string, unit: string) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    setSensor({ name: name, unit: unit });
  };

  // const url = `http://localhost:3001/${range}`;
  let url = `https://dv3dq7urbg.execute-api.eu-central-1.amazonaws.com/sensors/${groupId}?period=${range}`;
  if (startyeardef === undefined) { }
  else if (startyeardef > 2000) {
    url = `https://dv3dq7urbg.execute-api.eu-central-1.amazonaws.com/sensors/${groupId}?period=${range}&startyear=${startyeardef}&startmonth=${startmonthdef}&startday=${startdaydef}`;
  }
  const url2 = `https://y7rkgltm3apgr6tebt3g4lvgli0ladqr.lambda-url.eu-central-1.on.aws/?group_id=${groupId}`;

  useEffect(() => {
    setError(false) //fetching something so error is false for now
    fetch(url2)
      .then((response) => {
        setLoading(true)
        return response.json()
      })
      .then((res) => {
        if (res && res.length > 0) {
          setCurrentStatus?.(res);
          console.log("Got status from Lambda URL: success");
          // console.log(res);
        }
        else {
          console.log("Got no notice topic information for this sensor group.")
        }
      })
      .catch(err => {
        console.log("Some error 2")
      })
    fetch(url)
      .then((response) => {
        setLoading(true)
        setError(false)
        return response.json()
      })
      .then((res) => {
        if (res && res.length > 0) {
          setData(res.reverse());
          setCurrentData?.(res);
          setLoading(false)
          setError(false)
        }
        else {
          setError(true)
        }
      })
      .catch(err => {
        setError(true)
      })
  }, [range, reload, groupId]);


  useEffect(() => {
    setLoading(true)
  }, [range, startyear]);

  // turned off to save server resources
  // for re-fetching after a interval
 /*useEffect(() => {
    const interval = setInterval(() => {
      setReload(!reload);
    }, 600000);

    return () => clearInterval(interval); // important
  }, [dataOne]);
  */

  let { chartData, trueMin, trueMax, stepSize, unitMap } = useMemo(() => makeChartData(dataOne, showAllSensors, showRawData, showSD, sensorsOnGraph), [sensorsOnGraph, dataOne, showAllSensors, showRawData, showSD])

  const selectedButtonStyle = {
    backgroundColor: "green",
  }
  return (
    <div className="chart-container">
      <div className="chart-container-selection">
        <div className="chart-container-selection--dropdown">
          <ul>
            <li className="select">
              <select name="sensors" id="sensor" onChange={(e) => handleChange(e)}>
                <option defaultValue="1" value="24hrs">24 hours</option>
                <option value="2">2 days</option>
                <option value="3">3 days</option>
                <option value="5">5 days</option>
                <option value="7">7 days</option>
                <option value="10">10 days</option>
                <option value="14">14 days</option>
              </select>
            </li>
          </ul>
        </div>
        <div className="chart-container-selection--toggle">
          {Object.keys(graphingMap).map((key: string) => {
            const metric = graphingMap[key]
            return (
              <button
                style={metric.name === sensor.name ? selectedButtonStyle : {}}
                value={metric.unit}
                key={metric.name}
                onClick={(e) => handleDataSet(e, metric.name, metric.unit)}>
                {metric.name}
              </button>)
          })}
        </div>
        <div className="chart-container-selection--toggle">
          <button onClick={() => setExportModalOpen(true)}>
            Export ...
          </button>
          <ExportModal
            closeModal={() => setExportModalOpen(false)}
            isOpen={exportModalOpen}
            data={dataOne}
          />
        </div>
      </div>
      {!loading && !error && <LineChart id="chart-line"
        data={chartData[sensor.name as keyof Object] as any}
        trueMin={trueMin}
        trueMax={trueMax}
        stepSize={stepSize}
        sensor={sensor}
        unitMap={unitMap}
        groupId={groupId}
        showSD={showSD}
        showAvg={showAvg}
        sensorsOnGraph={sensorsOnGraph}
        setSensorsOnGraph={setSensorsOnGraph}
      />}
      {loading && !error &&
        <div
          style={{
            width: "100%",
            display: "inline-flex",
            justifyContent: "center"
          }}
        >
          <ColorRing
            visible={true}
            height="500"
            width="500"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
          />
        </div>
      }
      {error &&
        <div
          style={{
            width: "100%",
            display: "inline-flex",
            justifyContent: "center"
          }}
        >
          <h1>Something went wrong</h1>
        </div>
      }
      <div style={{ display: "flex" }}>

        <div className="chart-container-selection--toggle">
          <button
            style={showRawData ? selectedButtonStyle : {}}
            onClick={() => setShowRawData(!showRawData)}
          >
            {showRawData ? "Show hourly average" : "Show raw data"}
          </button>
          <button
            style={showSD ? selectedButtonStyle : {}}
            onClick={() => setShowSD(!showSD)}
          >
            {!showSD ? "Show SD" : "Remove SD"}
          </button>
          <button
            style={showAvg ? selectedButtonStyle : {}}
            onClick={() => setShowAvg(!showAvg)}
          >
            {!showAvg ? "Show Avg." : "Remove Avg."}
          </button>
        </div>
      <div className="chart-container-selection">
          Until:&nbsp;
      </div>
      <div className="chart-container-selection--dropdown">
          <ul>
            <li className="select">
              <select name="startyear" defaultValue="0" id="startyear" onChange={(e) => handleTimeChange(e)}>
                <option value="0">Latest data</option>
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </select>
            </li>
          </ul>
        </div>
      <div className="chart-container-selection--dropdown">
          <ul>
            <li className="select">
              <select name="startmonth" id="startmonth" onChange={(e) => handleTimeChange(e)}>
                <option value="1">--</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </li>
          </ul>
        </div>
      <div className="chart-container-selection--dropdown">
          <ul>
              <li className="select">
              <select name="startday" id="startday" onChange={(e) => handleTimeChange(e)}>
                <option value="1">--</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
              </select>
          </li></ul>
      </div>
      <div className="chart-container-selection">
          &nbsp;Select a period at the top to reload
      </div>

      </div>
    </div>
  );
};

export default Charts;
